import { render } from "./AboutPanel.vue?vue&type=template&id=1b31bbcc&scoped=true"
import script from "./AboutPanel.vue?vue&type=script&lang=js"
export * from "./AboutPanel.vue?vue&type=script&lang=js"

import "./AboutPanel.vue?vue&type=style&index=0&id=1b31bbcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b31bbcc"]])

export default __exports__